import React, { useState, useEffect } from "react";
import ReactLoading from "react-loading";
import { HeroSlider } from "../Slider/Slider";
import { URL } from "../AxiosUrlGlobal";
import axios from "axios";

const Banner = () => {
  const [SliderData, setSliderData] = useState();
  const [loadingSlider, setLoadingSlider] = useState(true);

  useEffect(() => {
    axios
      .get(`${URL}/e-banner`)
      .then((res) => {
        setSliderData(res.data.Data);
        setLoadingSlider(false);
      })
      .catch((error) => {
        console.log(error.response.data);
        setLoadingSlider(false);
      });
  }, []);

  return (
    <>
      {loadingSlider ? (
        <div className="category-loading">
          <div
            style={{
              width: "100vw",
              height: "90vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "20px",
              transition: "1s",
            }}
          >
            <ReactLoading type={"spin"} color={"#333"} height={50} width={50} />
          </div>
        </div>
      ) : (
        <HeroSlider heroSlices={SliderData} />
      )}
    </>
  );
};

export default Banner;
